import React, { FC, VFC, useEffect, useState } from 'react';
import { ReactComponent as AddPetAttributeIcon } from '@/assets/img/pet-emoji.svg';
import { ReactComponent as PetsIcon } from '@/assets/img/profile-pic.svg';
import { ReactComponent as AddPhotoIcon } from '@/assets/img/add-pet-image.svg';

import './PetInfo.scss';
import { ReactComponent as PetCat } from '@/assets/img/pet-cat-default.svg';
import { ReactComponent as AddNotesIcon } from '@/assets/img/add-notes-pet.svg';
import { Pets } from '@/features/customers';

type PetInfoProps = {
  data?: Pets;
  onAddAttribute?: (pet?: Pets) => void;
  onAddNotes?: (pet?: Pets) => void;
  onAddPhoto?: (pet?: Pets) => void;
  variant: 'small' | 'big';
  showPetBreed?: boolean;
  isBoarding?: any;
  showPhotoIcon?: boolean;
};
const PetInfo = ({
  data,
  variant,
  onAddAttribute,
  onAddNotes,
  onAddPhoto,
  showPetBreed = false,
  isBoarding = false,
  showPhotoIcon = true,
}: PetInfoProps) => {
  const slicedPetAttributes = data?.petAttributes?.slice(0, 2);
  const onAdd = (editPetAttribute: boolean) => {
    onAddAttribute && onAddAttribute(editPetAttribute ? data : undefined);
  };
  const onAddNotesClick = (e: any) => {
    e.stopPropagation();
    onAddNotes && onAddNotes(data);
  };
  const onAddPhotoClick = () => {
    onAddPhoto && onAddPhoto(data);
  };
  return (
    <div className={`pet-info ${variant}`}>
      <div className="pet-profile" onClick={() => onAdd(false)}>
        {data?.petsImageUrl ? (
          <img src={data?.petsImageUrl} alt="pet icon" />
        ) : data?.petType?.toLowerCase() == 'cat' ? (
          <PetCat />
        ) : (
          <PetsIcon />
        )}
      </div>
      <div className="pet-details">
        {data?.name && (
          <p className="pet-name" title={data.name} onClick={() => onAdd(false)}>
            {data.name}
          </p>
        )}
        {!isBoarding && !showPetBreed ? (
          <div className="attributes">
            {slicedPetAttributes?.length ? (
              <>
                {showPhotoIcon && (
                  <span className="empty" onClick={() => onAddPhotoClick()}>
                    <AddPhotoIcon /> <span>Photo</span>
                  </span>
                )}
                <div className="stack-attribute">
                  {slicedPetAttributes.map((pa) => (
                    <span className="attribute-icon" onClick={() => onAdd(true)}>
                      {pa?.url && pa?.url?.indexOf('http') >= 0 ? (
                        <img src={pa.url}></img>
                      ) : (
                        <span>{pa.url}</span>
                      )}
                    </span>
                  ))}
                  {data?.petAttributes && data?.petAttributes?.length > 2 && (
                    <span className="count" onClick={() => onAdd(true)}>
                      +{data?.petAttributes.length - 2}
                    </span>
                  )}
                  {/* <span className="count">+3</span> */}
                </div>
              </>
            ) : (
              <>
                {!isBoarding && (
                  <>
                    {showPhotoIcon && (
                      <span className="empty" onClick={() => onAddPhotoClick()}>
                        <AddPhotoIcon /> <span>Photo</span>
                      </span>
                    )}
                    <span className="empty" onClick={() => onAdd(true)}>
                      <AddPetAttributeIcon /> <span>Add</span>
                    </span>
                  </>
                )}
              </>
            )}
          </div>
        ) : (
          <div>{data?.breed}</div>
        )}
      </div>
      {onAddNotes && <AddNotesIcon className="notes-icon" onClick={(e) => onAddNotesClick(e)} />}
    </div>
  );
};
export default PetInfo;
